import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import idlbayLogo from '../assets/idl2.png';
import idlbayLogoColor from '../assets/idl1.png'
import { useNavigate } from 'react-router-dom';
import GetInTouchForm from '../GetinTouchform/GetinTouch';
import useTheme from '../ColorConfig/usetheme';

const Header = () => {
  const colors=useTheme();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  const [showGetInTouch, setShowGetInTouch] = useState(false);
  const [serviceItems, setServiceItems] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const [currentLogo, setCurrentLogo] = useState(idlbayLogo);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMobileLogoClicked, setIsMobileLogoClicked] = useState(false);
    const [projectCategories, setProjectCategories] = useState([]);
  
  // NEW: Animation state variables
  const [animationProgress, setAnimationProgress] = useState(0);
  const [showColorLogo, setShowColorLogo] = useState(false);
  const [isAnimationActive, setIsAnimationActive] = useState(false);

  // Add scroll effect to header and trigger animations
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Trigger animations after component mounts
    setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

// NEW: Smooth logo animation with even slower, more elegant effect
const animateLogoChange = () => {
  if (isAnimationActive) return;
  
  setIsAnimationActive(true);
  setAnimationProgress(0);
  setShowColorLogo(!showColorLogo);
  
  // Much slower animation duration - increased from 1500ms to 2500ms
  const duration = 2500; // 2.5 second animation (67% slower than before)
  const steps = 60; // Double the steps for ultra-smooth animation
  const stepDuration = duration / steps;
  
  let currentStep = 0;
  
  const animateStep = () => {
    if (currentStep <= steps) {
      // Use cubic-bezier easing for even smoother progression
      const progress = currentStep / steps;
      // Cubic bezier easing for very smooth start and end
      const easedProgress = progress < 0.5 
        ? 4 * progress * progress * progress 
        : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1;
      
      setAnimationProgress(easedProgress * 100);
      currentStep++;
      setTimeout(animateStep, stepDuration);
    } else {
      // Animation complete
      setIsAnimationActive(false);
      setCurrentLogo(showColorLogo ? idlbayLogo : idlbayLogoColor);
    }
  };
  
  animateStep();
};

// Auto logo animation loop - increased interval from 4s to 6s
useEffect(() => {
  const logoInterval = setInterval(() => {
    if (!isLogoHovered && !isMobileLogoClicked && !isAnimationActive) {
      animateLogoChange();
    }
  }, 6000); // Changed from 4000 to 6000ms (50% slower)

  return () => clearInterval(logoInterval);
}, [isLogoHovered, isMobileLogoClicked, isAnimationActive, showColorLogo]);

  // Handle mobile logo click
  const handleMobileLogoClick = (e) => {
    if (window.innerWidth <= 992) {
      e.preventDefault();
      setIsMobileLogoClicked(true);
      animateLogoChange();
      
      // Navigate to home after animation
      setTimeout(() => {
        navigate('/');
        setIsMenuOpen(false);
      }, 600);
      
      // Reset mobile logo click state after 2 seconds
      setTimeout(() => {
        setIsMobileLogoClicked(false);
      }, 2000);
    }
  };

    const extractProjectCategories = (projectsData) => {
    const categories = new Set();
    
    projectsData.forEach(project => {
      if (project.category && project.category.trim() !== '') {
        categories.add(project.category.trim());
      }
    });
    
    // Convert Set to array of objects with proper structure for dropdown
    return Array.from(categories).map(category => ({
      id: category.toLowerCase().replace(/\s+/g, '-'),
      name: category,
      path: `/OurProjects`,
      description: `${category} Projects`,
      category: category
    }));
  };

  // FIXED: Updated parseAndCleanArray function
  const parseAndCleanArray = (data) => {
    if (Array.isArray(data)) {
      return data.filter(item => item && item.toString().trim() !== '');
    }
    
    if (typeof data === 'string') {
      try {
        const parsed = JSON.parse(data);
        if (Array.isArray(parsed)) {
          return parsed.filter(item => item && item.toString().trim() !== '');
        }
        return [];
      } catch (e) {
        console.error('Error parsing array data:', e);
        return [];
      }
    }
    
    return [];
  };

  // FIXED: Fetch services and products from API with proper data processing
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Fetch services
        const servicesResponse = await fetch('https://api.dremerz.net/api/DZ_8923_Idlbay_Services_ServicesList');
        if (!servicesResponse.ok) {
          throw new Error(`Services API error: ${servicesResponse.status}`);
        }
        const servicesData = await servicesResponse.json();
        
        // Fetch products
        const productsResponse = await fetch('https://api.dremerz.net/api/DZ_8923_Idlbay_Products_ProductsList');
        if (!productsResponse.ok) {
          throw new Error(`Products API error: ${productsResponse.status}`);
        }
        const productsData = await productsResponse.json();

                const projectsResponse = await fetch('https://api.dremerz.net/api/DZ_8923_Idlbay_OurProjects_OurProjectsList');
        if (!projectsResponse.ok) {
          throw new Error(`Projects API error: ${projectsResponse.status}`);
        }
        const projectsData = await projectsResponse.json();
        
        // FIXED: Transform API data with proper ID handling and JSON parsing
        const transformedServices = servicesData.map(service => ({
          id: service.id.toString(), // Ensure ID is string for consistency
          name: service.title,
          path: `/servicedetails/${service.id}`,
          description: service.description || "No description available",
          shortDescription: service.shortDescription || service.description || "No description available",
          image: service.image ? 
            (service.image.startsWith('http') ? service.image : `https://api.dremerz.net/uploads/${service.image}`) :
            "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
          // FIXED: Parse JSON fields properly
          features: parseAndCleanArray(service.features),
          benefits: parseAndCleanArray(service.benefits),
          fullDescription: service.fullDescription || service.description || "No description available",
          category: service.category || "Service"
        }));
        
        const transformedProducts = productsData.map(product => ({
          id: product.id.toString(), // Ensure ID is string for consistency
          name: product.title,
          path: `/productdetails/${product.id}`,
          description: product.description || "No description available",
          shortDescription: product.shortDescription || product.description || "No description available",
          image: product.image ?
            (product.image.startsWith('http') ? product.image : `https://api.dremerz.net/uploads/${product.image}`) :
            "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop&auto=format",
          // Add other fields that might be needed
          keyFeatures: product.keyFeatures ? JSON.parse(product.keyFeatures) : [],
          benefits: product.benefits ? JSON.parse(product.benefits) : [],
           modules: product.modules ? JSON.parse(product.modules) : [],
          fullDescription: product.fullDescription || product.description || "No description available",
          category: product.category || "Product"
        }));

          const transformedProjectCategories = extractProjectCategories(projectsData);
        
        
        setServiceItems(transformedServices);
        setProductItems(transformedProducts);
         setProjectCategories(transformedProjectCategories);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        // Set empty arrays instead of leaving undefined
        setServiceItems([]);
        setProductItems([]);
         setProjectCategories([]);
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  const navItems = [
    { name: 'Home', path: '/', sectionId: 'home' },
     { 
      name: 'Services', 
      path: '/services', 
      hasDropdown: true, 
      dropdownItems: serviceItems 
    },
     { 
      name: 'Products', 
      path: '/products', 
      hasDropdown: true, 
      dropdownItems: productItems 
    },
    { name: 'About Us', path: '/about' },
     { 
      name: 'Our Projects', 
      path: '/OurProjects', 
      hasDropdown: true, 
      dropdownItems: projectCategories },
   
   
    { name: 'Blog', path: '/blog' },
    { name: 'Contact Us', path: '/contactus' }
  ];

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleViewAllClick = (path, itemName) => {
  if (itemName === 'Our Projects') {
    navigate('/OurProjects', { 
      state: { 
        selectedCategory: 'All',
        fromHeader: true,
        filterType: 'all'
      } 
    });
  } else if (itemName === 'Services') {
    navigate('/services');
  } else if (itemName === 'Products') {
    navigate('/products');
  }
  
  setIsMenuOpen(false);
  setActiveDropdown(null);
};

const handleNavClick = (path, sectionId, itemId, e) => {
  console.log('Navigation clicked:', { path, sectionId, itemId });

  // Handle category-specific navigation for OurProjects
  if (itemId && path === '/OurProjects') {
    e.preventDefault();
    
    const categoryData = projectCategories.find(item => item.id.toString() === itemId.toString());
    
    if (categoryData) {
      navigate(path, { 
        state: { 
          selectedCategory: categoryData.category,
          fromHeader: true,
          filterType: 'category'
        } 
      });
    } else {
      navigate(path);
    }
    
    setIsMenuOpen(false);
    setActiveDropdown(null);
    return;
  }
  
  // Handle "View All Projects" click
  if (path === '/OurProjects' && !itemId) {
    e.preventDefault();
    navigate(path, { 
      state: { 
        selectedCategory: 'All',
        fromHeader: true,
        filterType: 'all'
      } 
    });
    setIsMenuOpen(false);
    setActiveDropdown(null);
    return;
  }
    
 // In handleNavClick function
if (itemId && path.startsWith('/productdetails/')) {
  e.preventDefault();
  
  const productData = productItems.find(item => item.id.toString() === itemId.toString());
  
  if (productData) {
    navigate(path, { 
      state: { 
        productData: {
          ...productData,
          // Ensure all required fields are present
          title: productData.name,
          id: productData.id,
          // Explicitly pass all parsed arrays
          keyFeatures: productData.keyFeatures || [],
          benefits: productData.benefits || [],
          modules: productData.modules || [],
          // Add any other fields that might be needed
          fullDescription: productData.fullDescription || productData.description
        }
      } 
    });
  } else {
    navigate(path);
  }
  
  setIsMenuOpen(false);
  setActiveDropdown(null);
  return;
}
    
    // FIXED: Handle product detail navigation
    if (itemId && path.startsWith('/productdetails/')) {
      e.preventDefault();
      
      const productData = productItems.find(item => item.id.toString() === itemId.toString());
      console.log('Product data found:', productData); // Debug log
      
      if (productData) {
        // Pass complete product data via state
        navigate(path, { 
          state: { 
            productData: {
              ...productData,
              // Ensure all required fields are present
              title: productData.name,
              id: productData.id
            }
          } 
        });
      } else {
        // Fallback navigation without state
        navigate(path);
      }
      
      setIsMenuOpen(false);
      setActiveDropdown(null);
      return;
    }
    
    // If it's a main nav item with dropdown (Services/Products)
     if (path === '/services' || path === '/products' || path === '/OurProjects')  {
      // Only navigate if it's a direct click (not a dropdown toggle on mobile)
      if (window.innerWidth > 992 || !e.target.closest('.dropdown-toggle')) {
        navigate(path);
        setIsMenuOpen(false);
        setActiveDropdown(null);
      }
      return;
    }
    
    if (location.pathname === '/' && sectionId) {
      e.preventDefault();
      setIsMenuOpen(false);
      setActiveDropdown(null);
      
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerHeight = document.querySelector('.navbar-custom').offsetHeight;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
    
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  const handleViewAllServices = (path) => {
    navigate(path);
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  // Handle dropdown toggle on mobile
  const handleDropdownToggle = (itemName, e) => {
    e.preventDefault();
    if (window.innerWidth <= 992) {
      setActiveDropdown(activeDropdown === itemName ? null : itemName);
    }
  };

  // Function to show GetInTouch form
  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setShowGetInTouch(true);
  };

  // Function to close GetInTouch form
  const closeGetInTouch = () => {
    setShowGetInTouch(false);
  };

  // NEW: Function to calculate number of columns needed for dropdown
  const calculateDropdownColumns = (items) => {
    if (items.length <= 6) return 1;
    return Math.ceil(items.length / 6);
  };

  // NEW: Function to split items into columns with 6 items each
  const splitItemsIntoColumns = (items, columns) => {
    const result = [];
    const itemsPerColumn = Math.ceil(items.length / columns);
    
    for (let i = 0; i < columns; i++) {
      result.push(items.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn));
    }
    
    return result;
  };

  return (
    <>
      {/* Bootstrap CSS CDN */}
      <link 
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css" 
        rel="stylesheet" 
      />
      
      {/* Font Awesome for dropdown icons */}
      <link 
        rel="stylesheet" 
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" 
      />
      
      <style>
        {`
          /* Animation keyframes */
          @keyframes slideInFromTop {
            0% {
              opacity: 0;
              transform: translateY(-30px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          /* NEW: Logo slide animation */
          @keyframes logoSlideIn {
            0% {
              clip-path: inset(0 100% 0 0);
            }
            100% {
              clip-path: inset(0 0 0 0);
            }
          }
          
          .logo-container {
            position: relative;
            display: inline-block;
            height: 100%;
            width: auto;
          }
          
          .logo-base {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: auto;
            object-fit: contain;
          }
          
       .logo-color-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: auto;
  object-fit: contain;
  clip-path: inset(0 ${100 - animationProgress}% 0 0);
  transition: clip-path 0.1s ease-in-out; /* Changed from 0.05s linear to 0.1s ease-in-out */
}
          
          /* FIXED: Simplified modal overlay styles */
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(62, 62, 62, 0.8);
            backdrop-filter: blur(1px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1040;
            padding: 20px;
          }
          
          .modal-content-custom {
            position: relative;
            max-width: 500px;
            width: 100%;
            max-height: 90vh;
            overflow-y: auto;
          }

          .close-button{
            position: absolute;
            top: 10px;
            right: 10px;
            background: rgba(0, 0, 0, 0.1);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${colors.black};
            //  color: ${colors.white};
            font-size: 1.5rem;
            cursor: pointer;
            z-index: 10;
            transition: all 0.3s ease;
          }
          
          /* FIXED: Header styling with 60px height */
          .navbar-custom {
            background: ${isScrolled ? `linear-gradient(135deg, ${colors.bodyBlack} 0%, ${colors.bodyBlack} 100%)` : `linear-gradient(to right, ${colors.bodyBlack}, ${colors.bodyBlack})`};
            padding: 0.6rem 1rem;
            height: 75px;
            overflow: visible;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 1030;
            transition: all 0.3s ease;
            backdrop-filter: ${isScrolled ? 'blur(10px)' : 'none'};
            box-shadow: ${isScrolled ? '0 2px 20px rgba(0, 0, 0, 0.1)' : 'none'};
          }
          
          /* FIXED: Container fluid for proper flex layout */
          .navbar-custom .container-fluid {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 100%;
          }
          
          /* FIXED: Desktop Brand container - Made logo always visible */
         .navbar-brand-custom {
  display: flex !important;
  align-items: center;
  height: 100%;
  position: relative;
  z-index: 10;
  margin-right: 1rem;
  opacity: 1 !important;
  animation: none;
  flex-shrink: 0;
  text-decoration: none;
  padding: 5px 10px;
  transition: none !important; /* Remove any container transitions */
}
          
     
.headerlogo-img {
  height: 55px !important;
  width: auto !important;
  max-width: 250px;
  min-width: 150px;
  object-fit: contain;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  margin: 0;
  padding: 0;
  transition: opacity 0.3s ease-in-out; /* Smooth opacity transition */
}
          
          .nav-link-custom {
            color: ${colors.white} !important;
            font-weight: 500;
            margin: 0 0.2rem;
            transition: all 0.3s ease;
            padding: 0.2rem 1rem !important;
            border-radius: 0.5rem;
            text-decoration: none;
            display: block;
            position: relative;
            overflow: hidden;
            opacity: 0;
            animation: ${isLoaded ? 'slideInFromTop 0.6s ease-out forwards' : 'none'};
          }
          
          /* Stagger animation for nav items */
          .nav-item:nth-child(1) .nav-link-custom { animation-delay: 0.2s; }
          .nav-item:nth-child(2) .nav-link-custom { animation-delay: 0.25s; }
          .nav-item:nth-child(3) .nav-link-custom { animation-delay: 0.3s; }
          .nav-item:nth-child(4) .nav-link-custom { animation-delay: 0.35s; }
          .nav-item:nth-child(5) .nav-link-custom { animation-delay: 0.4s; }
          .nav-item:nth-child(6) .nav-link-custom { animation-delay: 0.45s; }
          .nav-item:nth-child(7) .nav-link-custom { animation-delay: 0.5s; }
          
          .nav-link-custom::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 0;
            height: 2px;
            background: ${colors.white};
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }
          
          .nav-link-custom:hover {
            color: ${colors.white} !important;
            transform: translateY(-2px);
          }
          
          .nav-link-custom:hover::after {
            width: calc(100% - 2rem);
          }
          
          /* Updated active state with conditional colors */
          .nav-link-custom.active {
            color: ${isScrolled ? `var(--color-primary)  !important` : `${colors.white} !important`};
            font-weight: 600;
          }
          
          .nav-link-custom.active::after {
            width: calc(100% - 2rem);
            background: ${isScrolled ? `linear-gradient(90deg, var(--color-primary), ${colors.primaryHover})` : colors.white};
          }
          
          /* Dropdown Styles */
          .nav-item.dropdown {
            position: relative;
          }
          
          /* Dropdown Styles - Only show on text hover */
          .nav-item.dropdown {
            position: relative;
          }

          .dropdown-menu-custom {
            position: absolute;
            top: 100%;
            left: 0;
            background: ${colors.deepBlack};
            backdrop-filter: blur(10px);
            border: none;
            border-radius: 0.5rem;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
            min-width: 50px;
            opacity: 0;
            visibility: hidden;
            transform: translateY(-10px);
            transition: all 0.3s ease;
            z-index: 1000;
            margin-top: 0.1rem;
            padding: 5px 5px; /* Added padding to dropdown */
          }

          /* Only show dropdown when hovering over the nav link text */
          .nav-item.dropdown .nav-link-custom:hover ~ .dropdown-menu-custom,
          .nav-item.dropdown .dropdown-menu-custom:hover {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
          }
          
          .dropdown-item-custom {
    color: ${colors.white};
    padding: 0rem 1rem; /* Increased padding for dropdown items */
    text-decoration: none;
    display: block;
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    margin-bottom: 1rem;
    font-weight: 90;
    // background: var(--color-primaryLight);
    // border-bottom: 1px solid var(--color-primaryTransparent); /* Corrected property */
}
          
          .dropdown-allitem-custom {
            color: var(--color-primary);
            // padding: 0.5rem 1rem; /* Increased padding for "View All" item */
            text-decoration: none;
            display: block;
            transition: all 0.3s ease;
            border-radius: 0.25rem;
            // margin: 0.1rem;
            font-weight: 90;
            text-align: center;
            // margin-top: 10px;
            border-top: 1px solid rgba(255,255,255,0.1);
          }

          .dropdown-menu-custom .row {
            display: flex;
            margin: 0;
            width: 100%;
          }

          .dropdown-menu-custom .col-6 {
            padding: 0.5rem; /* Added padding to columns */
            flex: 0 0 60%;
            max-width: 60%;
          }
          
          .dropdown-item-custom:hover {
            background: linear-gradient(to right, ${colors.hoverBlack}, ${colors.hoverBlack});
            color: var(--color-primary);
            text-decoration: none;
            transform: translateX(5px);
            font-weight: 90;
          }
          
          .dropdown-allitem-custom:hover {
            background: linear-gradient(to right, ${colors.hoverBlack}, ${colors.hoverBlack});
            text-decoration: none;
            transform: translateX(5px);
            font-weight: 90;
          }
          
          .btn-custom {
            border: 1px solid var(--color-primary);
            color: ${colors.white};
            font-weight: 500;
            transition: all 0.3s ease;
            white-space: nowrap;
            text-decoration: none;
            display: inline-block;
            opacity: 0;
            animation: ${isLoaded ? 'slideInFromTop 0.6s ease-out forwards' : 'none'};
            animation-delay: 0.55s;
            background: var(--color-primary);
          }
          
          .btn-custom:hover {
            background: linear-gradient(to right, var(--color-white), var(--color-white));
            color: var(--color-primary);
             border: 1px solid var(--color-primary);
            transform: translateY(-2px);
            text-decoration: none;
          }
          
          .navbar-toggler-custom {
            border: none;
            color: ${colors.white};
            padding: 0.25rem 0.5rem;
            opacity: 0;
            animation: ${isLoaded ? 'slideInFromTop 0.6s ease-out forwards' : 'none'};
            animation-delay: 0.15s;
            background: none;
            font-size: 1.2rem;
            order: 3;
          }
          
          .navbar-toggler-custom:focus {
            box-shadow: none;
          }
          
          .centered-nav {
            flex-grow: 1;
            justify-content: center;
          }
          
          .navbar-collapse {
            align-items: center;
          }
          
          /* NEW: Desktop dropdown column styling */
          @media (min-width: 993px) {
            .close-button{
            position: absolute;
            top: 10px;
            right: 35px;
            background: rgba(77, 77, 77, 0.1);
            border: none;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${colors.black};
              // color: ${colors.white};
            font-size: 1.5rem;
            cursor: pointer;
            z-index: 10;
            transition: all 0.3s ease;
          }
          
            .dropdown-menu-custom .dropdown-column {
              flex: 1;
              min-width: 220px;
              padding: 0.5rem;
            }
            
            .dropdown-menu-custom .dropdown-columns-container {
              display: flex;
              flex-wrap: nowrap;
              // width: 100%;
               min-width: 250px
            }
          }
          
          /* FIXED: Desktop body padding to match header height */
          body {
            padding-top: 60px;
          }
          
          /* Desktop-specific logo styling */
          @media (min-width: 993px) {
         .navbar-brand-custom {
  display: flex !important;
  align-items: center;
  height: 100%;
  position: relative;
  z-index: 10;
  margin-right: 1rem;
  opacity: 1 !important;
  animation: none;
  flex-shrink: 0;
  text-decoration: none;
  padding: 5px 10px;
  transition: none !important; /* Remove any container transitions */
}
            
            /* UPDATED: Desktop logo size - Increased from 80px to 100px */
           .headerlogo-img {
    height: 45px !important;
    width: auto !important;
    min-width: 150px;
    max-width: 200px;
    opacity: 1 !important;
    visibility: visible !important;
    display: block !important;
    object-fit: contain;
    transition: opacity 0.3s ease-in-out; /* Smooth opacity transition */
  }


            
            /* Ensure container layout works properly */
            .navbar-custom .container-fluid {
              position: relative;
            }
          }
          
     /* MOBILE RESPONSIVE STYLES - FIXED DROPDOWN ISSUES */
@media (max-width: 992px) {
  /* Mobile header height and structure */
  .navbar-custom {
    height: 60px;
    padding: 0.1rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  /* Body padding for mobile */
  body {
    padding-top: 60px;
  }
  
  /* Brand container for mobile - FIXED POSITIONING */
  .navbar-brand-custom {
    width: auto;
    margin-right: auto;
    height: 100%;
    display: flex;
    align-items: center;
    order: 1;
    border: none !important;
    background: none !important;
    padding: 5px 10px;
    position: relative;
    left: 0;
    transform: none;
  }
  
  /* FIXED: Mobile logo container positioning */
  .logo-container {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    width: auto;
    left: 0 !important;
    transform: none !important;
  }
  
  /* FIXED: Mobile logo sizing and positioning */
  .headerlogo-img {
    height: 35px !important;
    width: auto;
    object-fit: contain;
    position: relative;
    transform: none !important;
    top: auto !important;
    left: -20px !important;
    min-width: 100px;
    border: none !important;
    background: none !important;
    transition: opacity 0.3s ease-in-out;
  }

  /* FIXED: Ensure both logos are perfectly aligned in mobile */
  .logo-base,
  .logo-color-overlay {
    position: absolute;
    top: 50% !important;
    left: -20px !important;
    transform: translateY(-50%) !important;
    height: 35px !important;
    width: auto;
    object-fit: contain;
  }

  /* Mobile toggler positioning */
  .navbar-toggler-custom {
    order: 3;
    margin-left: auto;
    padding: 0.25rem;
  }
  
  .centered-nav {
    justify-content: flex-start;
    order: 2;
    flex-grow: 0;
  }
  
  /* FIXED: Mobile menu styling with proper overflow handling */
  .navbar-collapse {
    background: ${colors.white};
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    max-height: calc(100vh - 60px);
    overflow-y: auto;
    overflow-x: hidden; /* ADDED: Prevent horizontal scroll */
    padding: 1rem;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 10px 10px;
    z-index: 1000;
    width: 100%;
  }
  
  /* FIXED: Mobile nav links styling with proper spacing */
  .navbar-collapse .nav-link-custom {
    color: #333333 !important;
    padding: 0.75rem 1rem !important;
    margin: 0.25rem 0;
    border-radius: 8px;
    font-weight: 600;
    white-space: nowrap;
  }
  
  .navbar-collapse .nav-link-custom:hover {
    background: #f8f9fa;
    color: var(--color-primary) !important;
  }
  
  .navbar-collapse .nav-link-custom.active {
    color: var(--color-primary) !important;
    background: #f3f4f6;
  }
  
  /* FIXED: Mobile dropdown adjustments - NO horizontal scroll */
  .dropdown-menu-custom {
    position: static;
    opacity: 1;
    visibility: visible;
    transform: none;
    background: #f8f9fa;
    margin: 0.3rem 0 0.9rem;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 0.2rem;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box; /* ADDED: Ensure proper box sizing */
    overflow: hidden; /* ADDED: Prevent any overflow */
  }
  
  /* FIXED: Mobile dropdown - FORCE single column layout */
  .dropdown-menu-custom .row {
    margin: 0;
    width: 100%;
    display: block; /* CHANGED: Force single column */
    flex-wrap: nowrap;
  }

  .dropdown-menu-custom .col-6 {
    padding: 0.25rem 0.5rem; /* REDUCED: Less horizontal padding */
    flex: none; /* CHANGED: Remove flex properties */
    width: 100%; /* CHANGED: Full width for single column */
    max-width: 100%;
    box-sizing: border-box;
    display: block; /* ADDED: Block display */
  }
  
  .nav-item.dropdown .dropdown-menu-custom {
    display: none;
  }
  
  .nav-item.dropdown.show .dropdown-menu-custom {
    display: block;
  }
  
  /* FIXED: Mobile dropdown items - single column layout */
  .dropdown-item-custom {
    color: #555555;
    padding: 0.5rem 0.75rem;
    font-weight: 500;
    font-size: 0.85rem;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.3;
    display: block;
    width: 100%;
    // margin-bottom: 5px;
    box-sizing: border-box;
    margin-bottom: 0.25rem; /* ADDED: Space between items */
  }
  
  .dropdown-item-custom:hover {
    background: #e9ecef;
    color: var(--color-primary);
    font-weight: 600;
  }

  /* FIXED: Mobile "View All" button styling */
  .dropdown-allitem-custom {
    color: var(--color-primary);
    padding: 0.5rem 0.75rem;
    font-weight: 600;
    text-align: center;
    margin-top: 0.5rem;
    // border-top: 1px solid rgba(0,0,0,0.1);
    font-size: 0.9rem;
    width: 100%;
    box-sizing: border-box;
  }
  
  .dropdown-allitem-custom:hover {
    background: #e9ecef;
    font-weight: 700;
  }
  
  /* Mobile CTA button styling */
  .navbar-collapse .btn-custom {
    background: var(--color-primary);
    color: ${colors.white};
    margin-top: 1rem;
    width: 100%;
    padding: 0.75rem;
    border-radius: 8px;
    font-weight: 600;
  }
  
  .navbar-collapse .btn-custom:hover {
    background: ${colors.primaryHover};
    color: ${colors.white};
    font-weight: 700;
  }
  
  /* Reset animations for mobile menu items */
  .navbar-collapse .nav-link-custom,
  .navbar-collapse .btn-custom {
    animation: none;
    opacity: 1;
  }
  
  /* Modal adjustments for mobile */
  .modal-overlay {
    padding: 10px;
  }
  
  .modal-content-custom {
    max-height: 95vh;
  }

  /* FIXED: Mobile scrollbar styling */
  .navbar-collapse::-webkit-scrollbar {
    width: 4px;
  }
  
  .navbar-collapse::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  .navbar-collapse::-webkit-scrollbar-thumb {
    background: var(--color-primary);
    border-radius: 2px;
  }
  
  .navbar-collapse::-webkit-scrollbar-thumb:hover {
    background: ${colors.primaryHover};
  }
}

/* FIXED: Extra small screens - maintain single column */
@media (max-width: 576px) {
  .navbar-collapse {
    padding: 0.75rem;
  }
  
  /* FORCE single column on all screen sizes */
  .dropdown-menu-custom .col-6 {
    flex: none;
    width: 100%;
    max-width: 100%;
    display: block;
  }
  
  .dropdown-item-custom {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
}
        `}
      </style>
      
   <header style={{ margin: 0, padding: 0 }}>
        <nav className="navbar navbar-expand-lg navbar-custom">
          <div className="container-fluid">
            {/* Logo */}
            <Link 
              className="navbar-brand navbar-brand-custom" 
              to="/"
              onMouseEnter={() => setIsLogoHovered(true)}
              onMouseLeave={() => setIsLogoHovered(false)}
              onClick={handleMobileLogoClick}
            >
              <div className="logo-container">
                <img 
                  src={idlbayLogo} 
                  alt="IDLBAY Logo" 
                  className="headerlogo-img logo-base"
                />
                <img 
                  src={idlbayLogoColor} 
                  alt="IDLBAY Logo Color" 
                  className="headerlogo-img logo-color-overlay"
                  style={{
                    clipPath: `inset(0 ${100 - animationProgress}% 0 0)`
                  }}
                />
              </div>
            </Link>

            {/* Mobile Menu Button */}
            <button 
              className="navbar-toggler navbar-toggler-custom" 
              type="button" 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle navigation"
            >
              {isMenuOpen ? (
                <i className="fas fa-times" style={{ color: colors.white, fontSize: '1.2rem' }}></i>
              ) : (
                <span className="navbar-toggler-icon" style={{
                  backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`
                }}></span>
              )}
            </button>

            {/* Desktop Navigation */}
            <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
              <ul className="navbar-nav centered-nav mb-2 mb-lg-0">
                {navItems.map((item, index) => (
                  <li 
                    key={index} 
                    className={`nav-item ${item.hasDropdown ? 'dropdown' : ''} ${
                      activeDropdown === item.name ? 'show' : ''
                    }`}
                  >
                    {item.hasDropdown ? (
                      <>
                        <Link 
                          className={`nav-link nav-link-custom ${isActive(item.path) ? 'active' : ''}`} 
                          to={item.path}
                          onClick={(e) => {
                            if (window.innerWidth <= 992) {
                              handleDropdownToggle(item.name, e);
                            } else {
                              handleNavClick(item.path, null, null, e);
                            }
                          }}
                        >
                          {item.name}
                          <i className="fas fa-chevron-down ms-1" style={{ fontSize: '0.8rem' }}></i>
                        </Link>
                        <div className="dropdown-menu-custom" style={{
                          minWidth: window.innerWidth > 992 
                            ? (item.dropdownItems.length > 6 ? `${Math.min(calculateDropdownColumns(item.dropdownItems), 4) * 200}px` : '200px')
                            : '200px'
                        }}>
                          {/* Desktop dropdown with 6 items per column */}
                          {window.innerWidth > 992 && item.dropdownItems.length > 6 ? (
                            <div className="dropdown-columns-container">
                              {splitItemsIntoColumns(item.dropdownItems, calculateDropdownColumns(item.dropdownItems)).map((column, columnIndex) => (
                                <div key={columnIndex} className="dropdown-column">
                                  {column.map((dropdownItem, dropdownIndex) => (
                                    <Link
                                      key={dropdownIndex}
                                      className="dropdown-item-custom"
                                      to={dropdownItem.path}
                                      onClick={(e) => {
                                        handleNavClick(dropdownItem.path, null, dropdownItem.id, e);
                                        setIsMenuOpen(false);
                                        setActiveDropdown(null);
                                      }}
                                    >
                                      {dropdownItem.name}
                                    </Link>
                                  ))}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div>
                              {item.dropdownItems.map((dropdownItem, dropdownIndex) => (
                                <Link
                                  key={dropdownIndex}
                                  className="dropdown-item-custom"
                                  to={dropdownItem.path}
                                  onClick={(e) => {
                                    handleNavClick(dropdownItem.path, null, dropdownItem.id, e);
                                    setIsMenuOpen(false);
                                    setActiveDropdown(null);
                                  }}
                                >
                                  {dropdownItem.name}
                                </Link>
                              ))}
                            </div>
                          )}
                        <div 
  className="dropdown-allitem-custom"
  onClick={(e) => {
    handleViewAllClick(item.path, item.name);
  }}
  style={{cursor: 'pointer'}}
>
  {item.name === 'Our Projects' ? 'View All Projects' : 
   item.name === 'Services' ? 'View All Services' : 
   'View All Products'}
</div>
                        </div>
                      </>
                    ) : (
                      <Link 
                        className={`nav-link nav-link-custom ${isActive(item.path) ? 'active' : ''}`} 
                        to={item.path}
                        onClick={(e) => handleNavClick(item.path, item.sectionId, null, e)}
                      >
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
              
              {/* CTA Button */}
              <div className="d-flex ms-lg-2">
                <button
                  className="btn btn-custom px-3 py-1" 
                  onClick={handleGetStartedClick}
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </nav>

        {/* Get In Touch Modal */}
        {showGetInTouch && (
          <div className="modal-overlay" onClick={closeGetInTouch}>
            <div className="modal-content-custom" onClick={(e) => e.stopPropagation()}>
              <button className="close-button" onClick={closeGetInTouch}>
                &times;
              </button>
              <GetInTouchForm isModal={true} />
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;